export const environment = {
  production: false,
  apis:{
    blogs:"blogs",
    users:"users/vidhema-inquiry-form",
    AUTHOR:"authors",
    CATEGORY:"categories",
    job:"career/jobs",
    form:"career/form",
    careerCategory:"career/category",
    categoryJob:"career/category/jobs",
    questions:"career/question",
    application:"career/application"
  },
  // googleAnalyticsTrackingCode: 'google-site-verification=AHW_fofHY70hVRb0jDR8X9S6vsKU_mRGt3TrW0LimCk'
};

